export const visibilityOptions = [
  { label: "Reports", code: "forReports" },
  { label: "Quotation", code: "forQuotation" },
  { label: "Confirmation", code: "forConfirmation" },
  { label: "Voucher", code: "forVoucher" },
  { label: "Other", code: "forOther" },
  { label: "Web", code: "forWeb" },
  { label: "App", code: "forApp" },
];
export const getVisibilityOptionsFromContent = (content) => {
  return visibilityOptions.filter((o) => content[o.code]).map((o) => o.label);
};



// WEBPACK FOOTER //
// ./src/components/gt/shared/contents/visibility-options.js